import { nanoid } from "nanoid";
import React from "react";
import DataTable from "react-data-table-component";
import { ActivePill, InactivePill } from "./StatusPill";

const AccountHistoryTable = () => {
  const treeFellItemsColumns = [
    {
      name: "Account Name",
      selector: (row) => "Vodafone Cash",
    },
    {
      name: "Current Balance",
      selector: (row) => "GHS 0",
    },
    {
      name: "Previous Balance",
      selector: (row) => "GHS 0",
    },
    {
      name: "Total Balance",
      selector: (row) => "GHS 0",
    },
    {
      name: "Total Credit Balance",
      selector: (row) => "GHS 0",
    },
    {
      name: "Total Debit Balance",
      selector: (row) => "GHS 0",
    },
  
    {
      name: "Status",
      selector: (row) => row.isActive?<ActivePill >Active</ActivePill>:<InactivePill>Inactive</InactivePill>,
    },
  ];
  return (
    <div className="w-full">
      <DataTable
        className="w-full rounded rounded-lg"
        columns={treeFellItemsColumns}
        data={data}
        pagination
      />
    </div>
  );
};

export default AccountHistoryTable;

const data = [
  {
    description: "description",
    dimension: "dimension",
    quantity: "quantity",
    volume: "volume",
    status: "fell",
    id: nanoid(),
  },
  {
    description: "description",
    dimension: "dimension",
    quantity: "quantity",
    volume: "volume",
    status: "fell",
    id: nanoid(),
  },
  {
    description: "description",
    dimension: "dimension",
    quantity: "quantity",
    volume: "volume",
    status: "fell",
    id: nanoid(),
  },
];
